<template>
    <div>
        <b-row>
            <b-col>
                <app-form-input label="Nombre del evento" @input="$v.event.name.$touch()" :error="$v.event.name.$error" v-model="event.name"></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-input
                    label="Fecha de inicio del evento"
                    type="datetime-local"
                    @input="$v.event.eventDate.$touch()"
                    :error="$v.event.eventDate.$error"
                    v-model="event.eventDate"
                ></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-input
                    label="Fecha de finalización del evento"
                    type="datetime-local"
                    @input="$v.event.endDate.$touch()"
                    :error="$v.event.endDate.$error"
                    v-model="event.endDate"
                ></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-input label="Lugar del evento" @input="$v.event.place.$touch()" :error="$v.event.place.$error" v-model="event.place"></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-input
                    label="Hora permitida de ingreso"
                    type="datetime-local"
                    v-model="event.entryAt"
                    @input="$v.event.entryAt.$touch()"
                    :error="$v.event.entryAt.$error"
                ></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-textarea rows="6" v-model="event.description"></b-textarea>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <label for="banner">Banner</label>
                <b-form-file v-model="banner" accept="image/*" id="banner"></b-form-file>
                <small>Recomendado 970x250 px</small>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <label for="banner">Link de la carpeta de archivos</label>
                <app-form-input label="Link directorio de archivos" v-model="event.filesDirectoryLink"></app-form-input>
                <small>Link de directorio compartido en la nube</small>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
export default {
    props: {
        currentEvent: {
            type: Object,
        },
    },
    data: () => ({
        event: {
            name: '',
            eventDate: '',
            endDate: '',
            entryAt: '',
            description: '',
            place: '',
            filesDirectoryLink: '',
        },
        banner: null,
    }),
    validations: {
        event: {
            name: { required },
            eventDate: { required },
            endDate: {
                required,
                minValue(val, { eventDate }) {
                    return moment(val).isAfter(eventDate)
                },
            },
            entryAt: {
                minValue(val, { eventDate }) {
                    return !val || moment(eventDate).isAfter(val)
                },
            },
            place: { required },
        },
    },
    methods: {
        async save() {
            this.$v.$touch()

            if (this.$v.$invalid) return toastr.error('Debe diligenciar los campos adecuadamente')

            const banner = !!this.banner ? await this.fileToBase64(this.banner) : null

            try {
                const payload = {
                    ...this.event,
                    personId: this.currentPerson.id,
                    venueId: this.currentVenue.id,
                    eventDate: moment(this.event.eventDate).format('Y-MM-DD HH:mm:ss'),
                    entryAt: !!this.event.entryAt ? moment(this.event.entryAt).format('Y-MM-DD HH:mm:ss') : '',
                    banner,
                }
                const { data: event } = !this.currentEvent
                    ? await this.$repo.post('events', payload)
                    : await this.$repo.put(`events/${this.currentEvent.id}`, payload)

                this.$emit('success', event)
            } catch (error) {
                toastr.error('Ocurrió un error al guardar el evento, por favor intente de nuevo más tarde')
            }
        },
    },
}
</script>

<style></style>
